import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { loadBackOfficeInvitations } from 'store/modules/backOfficeInvitations/actions';

import { useBackOfficeInvitationsRequestParameters } from '../useBackOfficeRequestParameters';

export default function BackOfficeInvitationsRequest() {
  const dispatch = useDispatch();
  const parameters = useBackOfficeInvitationsRequestParameters();

  useDeepCompareEffect(() => {
    dispatch(loadBackOfficeInvitations(parameters));
  }, [dispatch, parameters]);

  return null;
}
